module.exports = __webpack_public_path__ + "static/img/2.0445fe3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/4/zh/2.png
// module id = qmu7
// module chunks = 0